import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import { AuthStep, AuthStepContext } from '@providers/AuthProvider';

import SMSCodeInputForm, { ISMSCodeInputFormContent } from './SMSCodeInputForm.component';

interface IUnverifiedSMSCodeInputFormProps {
	authStep: AuthStepContext;
	setAuthStep: (authStep: AuthStepContext) => void;
	onComplete: () => void;
	phoneNumber: string;
	resendCode: () => void;
}

const UnverifiedSMSCodeInputForm: FC<IUnverifiedSMSCodeInputFormProps> = ({
	authStep,
	setAuthStep,
	...props
}) => {
	const { pageContent } = useStaticQuery(
		graphql`
			{
				pageContent: butterPage(slug: { eq: "sms-code-input-form" }) {
					unverified {
						title
						change_number_link
					}
					description
					code_sent_message
					code_waiting_message
					resend_link
				}
			}
		`
	);

	const changePhoneNumber = () => {
		if ('user' in authStep)
			setAuthStep({ ...authStep, nextStep: AuthStep.needSMSMultifactorSetupPhone });
	};

	const refinedContent: ISMSCodeInputFormContent = keysToCamel({
		...pageContent,
		...pageContent?.unverified,
	}) as ISMSCodeInputFormContent;

	return (
		<SMSCodeInputForm
			authStep={authStep}
			setAuthStep={setAuthStep}
			pageContent={refinedContent}
			changePhoneNumber={changePhoneNumber}
			{...props}
		/>
	);
};

export default UnverifiedSMSCodeInputForm;
